<template>
  <CHeader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/" />

    <CHeaderNav class="mr-auto">
      <div class="header-context">
        <div class="header-title">{{ pageTitle }}</div>
      </div>
    </CHeaderNav>

    <CHeaderNav class="align-items-center">
      <TheHeaderDropdownNotif />
      <TheHeaderDropdownAccnt class="pr-3" />
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif
  },
  computed: {
    pageTitle() {
      const matchedWithTitle = [...this.$route.matched]
        .reverse()
        .find(route => route.meta && (route.meta.pageTitle || route.meta.pageTitleKey))

      const meta = (matchedWithTitle && matchedWithTitle.meta) || this.$route.meta || {}
      if (meta.pageTitleKey) {
        return this.$t(meta.pageTitleKey)
      }
      return meta.pageTitle
        || this.$route.name
        || 'Dashboard'
    }
  }
}
</script>

<style scoped>
.header-context {
  padding-left: 0.5rem;
}

.header-title {
  color: #5e1111;
  font-size: 1.55rem;
  font-weight: 700;
  line-height: 1.1;
}
</style>
